// dependencies
import $ from "jquery";

export default function() {
    // initVideoJS
    function initVideoJS() {
        var $videoJS = $('video-js');
        if ($videoJS.length > 0) {
            // Initiate VideoJS
            videojs();
        }
    }

    function initVideoVersion1() {

        $('.video-module a.play-video').on('click', function (e) {

            var videoModuleContainer = $(this).parents('.video-module');

            videoModuleContainer.find('figure').fadeOut('slow');
            hideVideoContent();
            videoModuleContainer.find('.close').fadeIn('slow');
            videoModuleContainer.find('.embed-responsive').css({'z-index': '9'});
            e.preventDefault();

            $('#curryVideo')[0].src += '?autoplay=1';

            function hideVideoContent() {
                if ($(window).width() > 768) {
                    videoModuleContainer.find('.container').fadeOut('slow');
                }
            }
        });

        $('.video-module a.close').on('click', function (e) {

            var videoModuleContainer = $(this).parents('.video-module');
            videoModuleContainer.find('figure').fadeIn();
            videoModuleContainer.find('.container').fadeIn();
            videoModuleContainer.find('.close').fadeOut('slow');
            videoModuleContainer.find('.embed-responsive').css({'z-index': '-1'});
            e.preventDefault();

            if ($('#curryVideo').length > 0) {
                var video = $("#curryVideo").attr("src");
                var videoURL = video.split('?')[0];
                $("#curryVideo").attr("src","");
                $("#curryVideo").attr("src",videoURL);
            }
            else if ($('#curryVideo2').length > 0) {
                videoModuleContainer.find('.play-button').fadeIn('slow');
                $('.full-width-video').toggleClass('hide-bg');
                videoModuleContainer.find('.video-caption').fadeIn();
                var video2 = $("#curryVideo2").attr("src");
                var videoURL2 = video2.split('?')[0];
                $("#curryVideo2").attr("src","");
                $("#curryVideo2").attr("src",videoURL2);
            }
        });

        $('.video-module a.play-button').on('click', function (e) {

            var videoModuleContainer = $(this).parents('.video-module');

            $('.full-width-video').toggleClass('hide-bg');
            videoModuleContainer.find('figure').fadeOut('slow');
            videoModuleContainer.find('.play-button').fadeOut('slow');
            videoModuleContainer.find('.video-caption').fadeOut('slow');
            videoModuleContainer.find('.close').fadeIn('slow');
            videoModuleContainer.find('.embed-responsive').css({'z-index': '9'});
            e.preventDefault();

            $('#curryVideo2')[0].src += '?autoplay=1';
        });


    }

    initVideoJS();
    initVideoVersion1();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/video.js